import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import PersianNumber from "../../../utils/PersianNumber/PersianNumber";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import ColorChangingIcon from "../../../helpers/ColorChangingIcon/ColorChangingIcon";
import MobileListUi from "../../../helpers/MobileListUi/MobileListUi";
import NewsModal from "../../../helpers/NewsModal/NewsModal";
import MenuUi from "../../../helpers/MenuUi/MenuUi";
import { decodeJWT } from "../../../utils";

import { TbClockCancel } from "react-icons/tb";
import { TbLoader } from "react-icons/tb";
import { AiFillNotification } from "react-icons/ai";

import { pricePublicContext } from "../../../context/PublicContext/PricePublicContext/PricePublicContext";

const MobilePriceView = () => {
  const userInfo = useSelector((state) => state.userInfo);
  const timerStatus = useSelector((state) => state.timerStatus);

  const token = localStorage.getItem("token");
  const roleName = decodeJWT(token)?.usertype;

  const {
    setIs_orderi,
    description,
    setDescription,
    setCustomeruser,
    product_name,
    setProduct_name,
    resultModal,
    setResultModal,
    orderModal,
    setOrderModal,
    data,
    setData,
    getItemsList,
    type,
    setType,
    stateWeight,
    setStateWeight,
    setBos,
    transactionId,
    statePrice,
    setStatePrice,
    stateTotal,
    setStateTotal,
    setCounter,
    handleGetItemsList,
    handlePostTransaction,
    handlePriceChange,
    handleWeightChange,
    handleTotalChange,
    addCommas,
    loading,
    setLoading,
    //* News Modal
    openModal,
    setOpenModal,
    //* Timer Of Order
    isTimerOn,
    setIsTimerOn,
    handleStartTimer,
    //* Update Product
    buyTolerance,
    setBuyTolerance,
    sellTolerance,
    setSellTolerance,
    handleChangeBuyPrice,
    handleChangeSellPrice,
    handleUpdateProduct,
    //* Is Price Close
    handleChangeBuyClosePriceProduct,
    handleChangeSellClosePriceProduct,
      handleChangeBuyAutoPilotProduct,
  handleChangeSellAutoPilotProduct,
  } = useContext(pricePublicContext);

  //* Get Data Start
  const handleInitial = async () => {
    setCounter((prevCounter) => prevCounter + 1);
    await handleGetItemsList();
  };

  useEffect(() => {
    const fetchData = async () => {
      await handleInitial();
      setLoading(false);
    };
    fetchData();

    const interval = setInterval(handleInitial, 1000);
    return () => clearInterval(interval);
  }, []);
  //* Get Data End

  //* Table Title
  const tableTitle = [
    { id: 1, title: "#" },
    { id: 2, title: "نام محصول" },
    { id: 3, title: "خرید شما(تومان)" },
    { id: 4, title: "فروش شما(تومان)" },
    { id: 5, title: "آخرین آپدیت" },
  ];

  //* Loading
  if (loading) {
    return (
      <span
        className="w-full h-full absolute space-y-5
      left-0 right-0 top-[2.5rem] text-gray-200 text-xl
      flex flex-col justify-center items-center"
      >
        <span>
          <TbLoader size={60} />
        </span>
        <p>لطفا صبر کنید</p>
      </span>
    );
  }

  return (
    <>
      <SiteTitle title="لیست قیمت ها" />
      {isEmpty(getItemsList) ? (
        <>
          {/* Menu */}
          <MenuUi className={"top-3"} />
          <span
            className="w-full h-full absolute space-y-5
            left-0 right-0 top-[2.5rem] text-gray-200 text-xl
            flex flex-col justify-center items-center"
          >
            <span>
              <TbClockCancel size={60} />
            </span>
            <p>سامانه بسته می باشد</p>
          </span>
        </>
      ) : (
        <>
          <div
            className={`${
              isEmpty(getItemsList) ? "h-screen" : "mt-2 mb-16 space-y-1"
            } w-full relative flex flex-col justify-center  overflow-auto z-20`}
          >
            {/* News */}
            <div
              className={`${
                isEmpty(getItemsList) ? "absolute top-1 left-0 " : null
              } w-full`}
            >
              <span className="flex justify-end mx-3 z-40">
                <ColorChangingIcon
                  Icon={AiFillNotification}
                  size={30}
                  firstColor="#ffe700"
                  secondColor="#ffffff"
                  onClick={() => setOpenModal(!openModal)}
                />
              </span>
              <span>
                <span
                  className="flex justify-center items-center
                  w-full h-full z- mb-8"
                >
                  {openModal && <NewsModal openModal={openModal} />}
                </span>
              </span>
            </div>
            {getItemsList.some(item => item.name === "مظنه فردایی") && (
  <div className="mx-3 mb-4">
    <div className="bg-[#1e2746] rounded-lg px-4 py-3 border border-[#2a3459] w-full">
      <div className="flex items-center justify-between">
        <span className="text-gray-400 text-sm font-medium">قیمت گرم:</span>
        <div className="flex items-center gap-2">
          <span className="text-yellow-400 text-base font-bold">
            {(() => {
              const targetItem = getItemsList.find(item => item.name === "مظنه فردایی");
              return targetItem && targetItem.buy_price !== -1 && targetItem.buy_price ? (
                <PersianNumber
                  value={Math.floor(targetItem.buy_price / 4.3318)}
                  thousandSeparator=","
                />
              ) : "-";
            })()}
          </span>
          <span className="text-gray-500 text-xs">تومان</span>
        </div>
      </div>
    </div>
  </div>
)}
            {/* Boxes */}
            <table className="w-full">
              {/* Table Header */}
              <thead className="text-sm font-medium text-gray-200 border-b-[1px] border-boxColor">
                <tr>
                  {tableTitle.map((_item) => (
                    <th key={_item?.id} className="py-3 pr-3">
                      <span>{_item?.title}</span>
                    </th>
                  ))}
                </tr>
              </thead>
              {/* Table Body */}
              <tbody className="text-lg divide-y divide-boxColor w-full">
                {getItemsList.map((_item, index) => (
                  <>
                    {_item.periority === true && (
                      <MobileListUi
                        roleName={roleName}
                        timerStatus={timerStatus}
                        index={index}
                        _item={_item}
                        data={data}
                        setData={setData}
                        resultModal={resultModal}
                        setResultModal={setResultModal}
                        orderModal={orderModal}
                        setOrderModal={setOrderModal}
                        statePrice={statePrice}
                        setStatePrice={setStatePrice}
                        handlePriceChange={handlePriceChange}
                        stateWeight={stateWeight}
                        setStateWeight={setStateWeight}
                        handleWeightChange={handleWeightChange}
                        stateTotal={stateTotal}
                        setStateTotal={setStateTotal}
                        handleTotalChange={handleTotalChange}
                        description={description}
                        setDescription={setDescription}
                        addCommas={addCommas}
                        type={type}
                        setType={setType}
                        handlePostTransaction={handlePostTransaction}
                        setProduct_name={setProduct_name}
                        setCustomeruser={setCustomeruser}
                        userInfo={userInfo}
                        setBos={setBos}
                        setIs_orderi={setIs_orderi}
                        transactionId={transactionId}
                        isTimerOn={isTimerOn}
                        setIsTimerOn={setIsTimerOn}
                        handleStartTimer={handleStartTimer}
                        buyTolerance={buyTolerance}
                        setBuyTolerance={setBuyTolerance}
                        sellTolerance={sellTolerance}
                        setSellTolerance={setSellTolerance}
                        handleChangeBuyPrice={handleChangeBuyPrice}
                        handleChangeSellPrice={handleChangeSellPrice}
                        handleUpdateProduct={handleUpdateProduct}
                        handleChangeBuyClosePriceProduct={
                          handleChangeBuyClosePriceProduct
                        }
                        handleChangeSellClosePriceProduct={
                          handleChangeSellClosePriceProduct
                        }
                          handleChangeBuyAutoPilotProduct={handleChangeBuyAutoPilotProduct}
  handleChangeSellAutoPilotProduct={handleChangeSellAutoPilotProduct}
                      />
                    )}
                  </>
                ))}
              </tbody>
              <tbody className="text-lg divide-y divide-boxColor w-full">
                {getItemsList.map((_item, index) => (
                  <>
                    {_item.periority === false && (
                      <MobileListUi
                        roleName={roleName}
                        timerStatus={timerStatus}
                        index={index}
                        _item={_item}
                        data={data}
                        setData={setData}
                        resultModal={resultModal}
                        setResultModal={setResultModal}
                        orderModal={orderModal}
                        setOrderModal={setOrderModal}
                        statePrice={statePrice}
                        setStatePrice={setStatePrice}
                        handlePriceChange={handlePriceChange}
                        stateWeight={stateWeight}
                        setStateWeight={setStateWeight}
                        handleWeightChange={handleWeightChange}
                        stateTotal={stateTotal}
                        setStateTotal={setStateTotal}
                        handleTotalChange={handleTotalChange}
                        description={description}
                        setDescription={setDescription}
                        addCommas={addCommas}
                        type={type}
                        setType={setType}
                        handlePostTransaction={handlePostTransaction}
                        setProduct_name={setProduct_name}
                        setCustomeruser={setCustomeruser}
                        userInfo={userInfo}
                        setBos={setBos}
                        setIs_orderi={setIs_orderi}
                        transactionId={transactionId}
                        isTimerOn={isTimerOn}
                        setIsTimerOn={setIsTimerOn}
                        handleStartTimer={handleStartTimer}
                        buyTolerance={buyTolerance}
                        setBuyTolerance={setBuyTolerance}
                        sellTolerance={sellTolerance}
                        setSellTolerance={setSellTolerance}
                        handleChangeBuyPrice={handleChangeBuyPrice}
                        handleChangeSellPrice={handleChangeSellPrice}
                        handleUpdateProduct={handleUpdateProduct}
                        handleChangeBuyClosePriceProduct={
                          handleChangeBuyClosePriceProduct
                        }
                        handleChangeSellClosePriceProduct={
                          handleChangeSellClosePriceProduct
                        }
                        handleChangeBuyAutoPilotProduct={handleChangeBuyAutoPilotProduct}
  handleChangeSellAutoPilotProduct={handleChangeSellAutoPilotProduct}
                      />
                    )}
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
};

export default MobilePriceView;
